export default __webpack_public_path__ + "static/media/quick-cash.ea828988.svg";